import React from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';

function useLerpedMouse() {
  const mouse = useThree((state) => state.mouse);
  const lerped = useRef(mouse.clone());
  const previous = new THREE.Vector2();
  useFrame((state) => {
    previous.copy(lerped.current);
    lerped.current.lerp(mouse, 0.1);
    // Regress system when the mouse is moved
    // if (!previous.equals(lerped.current)) state.performance.regress();
  });
  return lerped;
}

const Lights = () => {
  //   const lights = useRef<THREE.Group>();
  //   const mouse = useLerpedMouse();
  //   useFrame((state) => {
  //     if (lights.current) {
  //       lights.current.rotation.x = (mouse.current.x * Math.PI) / 2;
  //       lights.current.rotation.y =
  //         Math.PI * 0.25 - (mouse.current.y * Math.PI) / 2;
  //     }
  //   });
  return (
    <>
      <hemisphereLight args={[0xddeeff, 0x0f0e0d, 5]} />
      <directionalLight args={[0xffffff, 5]} position={[10, 10, 10]} />
      {/* <group ref={lights}>
        <rectAreaLight
          intensity={2}
          position={[4.5, 0, -3]}
          width={100}
          height={100}
          onUpdate={(self) => self.lookAt(0, 0, 0)}
        />
        <rectAreaLight
          intensity={2}
          position={[-10, 2, -10]}
          width={150}
          height={150}
          onUpdate={(self) => self.lookAt(0, 0, 0)}
        />
      </group> */}
    </>
  );
};

export default Lights;
